import React, { useState } from 'react';
import Button from '../common/Button';
import { theme } from '../../config/theme';
import { formatCurrency } from '../../utils/helpers';
import { TrashIcon } from '../icons/Icons';

const CartItem = ({ item, onUpdateQuantity, onRemove, loading }) => {
  const [quantity, setQuantity] = useState(item.quantity);

  const handleQuantityChange = (newQuantity) => {
    if (newQuantity < 1) return;
    setQuantity(newQuantity);
    onUpdateQuantity(item.id, newQuantity);
  };

  const itemStyles = {
    display: 'grid',
    gridTemplateColumns: '100px 1fr auto',
    gap: theme.spacing.lg,
    padding: theme.spacing.lg,
    backgroundColor: theme.colors.white,
    borderRadius: theme.borderRadius.lg,
    border: `1px solid ${theme.colors.gray[200]}`,
    marginBottom: theme.spacing.md,
  };

  const imageStyles = {
    width: '100px',
    height: '100px',
    objectFit: 'cover',
    borderRadius: theme.borderRadius.md,
  };

  const quantityControlStyles = {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing.sm,
    marginTop: theme.spacing.md,
  };

  const quantityButtonStyles = {
    width: '32px',
    height: '32px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: `1px solid ${theme.colors.gray[300]}`,
    borderRadius: theme.borderRadius.md,
    backgroundColor: theme.colors.white,
    cursor: 'pointer',
    fontSize: theme.typography.fontSize.lg,
    fontWeight: theme.typography.fontWeight.bold,
    transition: theme.transitions.base,
  };

  const quantityInputStyles = {
    width: '60px',
    textAlign: 'center',
    padding: `${theme.spacing.xs} ${theme.spacing.sm}`,
    border: `1px solid ${theme.colors.gray[300]}`,
    borderRadius: theme.borderRadius.md,
    fontSize: theme.typography.fontSize.sm,
  };

  return (
    <div style={itemStyles}>
      <img 
        src={item.product?.images?.[0] || '/placeholder.png'} 
        alt={item.product?.name}
        style={imageStyles}
      />

      <div>
        <h3 style={{ 
          fontSize: theme.typography.fontSize.base, 
          fontWeight: theme.typography.fontWeight.semibold,
          marginBottom: theme.spacing.xs,
        }}>
          {item.product?.name}
        </h3>
        
        {item.product?.category && (
          <div style={{ 
            fontSize: theme.typography.fontSize.sm, 
            color: theme.colors.text.secondary,
            marginBottom: theme.spacing.sm,
          }}>
            {item.product.category.name}
          </div>
        )}

        <div style={{ 
          fontSize: theme.typography.fontSize.lg, 
          fontWeight: theme.typography.fontWeight.bold,
          color: theme.colors.primary.main,
          marginBottom: theme.spacing.sm,
        }}>
          {formatCurrency(item.price)}
        </div>

        <div style={quantityControlStyles}>
          <button
            onClick={() => handleQuantityChange(quantity - 1)}
            disabled={loading || quantity <= 1}
            style={{
              ...quantityButtonStyles,
              opacity: loading || quantity <= 1 ? 0.5 : 1,
            }}
            onMouseEnter={(e) => {
              if (!loading && quantity > 1) {
                e.target.style.backgroundColor = theme.colors.gray[50];
              }
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = theme.colors.white;
            }}
          >
            −
          </button>
          
          <input
            type="number"
            min="1"
            value={quantity}
            onChange={(e) => handleQuantityChange(parseInt(e.target.value) || 1)}
            disabled={loading}
            style={quantityInputStyles}
          />
          
          <button
            onClick={() => handleQuantityChange(quantity + 1)}
            disabled={loading}
            style={{
              ...quantityButtonStyles,
              opacity: loading ? 0.5 : 1,
            }}
            onMouseEnter={(e) => {
              if (!loading) {
                e.target.style.backgroundColor = theme.colors.gray[50];
              }
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = theme.colors.white;
            }}
          >
            +
          </button>
        </div>
      </div>

      <div style={{ 
        display: 'flex', 
        flexDirection: 'column', 
        alignItems: 'flex-end',
        justifyContent: 'space-between',
      }}>
        <div style={{ 
          fontSize: theme.typography.fontSize.xl, 
          fontWeight: theme.typography.fontWeight.bold,
        }}>
          {formatCurrency(parseFloat(item.price) * item.quantity)}
        </div>

        <Button
          variant="ghost"
          size="sm"
          onClick={() => onRemove(item.id)}
          disabled={loading}
          style={{ color: theme.colors.error }}
        >
          <TrashIcon size={18} />
          Remove
        </Button>
      </div>
    </div>
  );
};

export default CartItem;